import { useMemo } from 'react';

import { OptLogVolumeActions } from '~/shared/types/api';

import { useOptLogActionDetails } from './useOptLogActionDetails';

export type ActionTableRow = OptLogVolumeActions & { _isSkeleton?: boolean };

export function isSkeletonActionRow(row: ActionTableRow): boolean {
  return row._isSkeleton === true;
}

export interface UseOptimizationActionsRowDataParams {
  tableQueryUrl: string;
  baseRowData: ActionTableRow[];
  canReadUsers: boolean;
  showLoader: boolean;
}

export function useOptimizationActionsRowData({
  tableQueryUrl,
  baseRowData,
  canReadUsers,
  showLoader,
}: UseOptimizationActionsRowDataParams): ActionTableRow[] {
  const actionsWithoutSkeleton = useMemo(
    () => baseRowData.filter((row) => !isSkeletonActionRow(row)),
    [baseRowData]
  );

  const rowDataWithDetails = useOptLogActionDetails({
    tableQueryUrl,
    actions: actionsWithoutSkeleton,
    canReadUsers,
    enabled: !showLoader,
  });

  return useMemo(() => {
    if (baseRowData.some(isSkeletonActionRow)) {
      return baseRowData;
    }
    return rowDataWithDetails;
  }, [baseRowData, rowDataWithDetails]);
}
